import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IExternalCourseParticipant } from 'models/externalCourseParticipant.model'
import { DestroyExternalCourseParticipantPayload } from '../sagas/externalCourseParticipants/destroy.saga'
import { ExternalCoursesListSort } from 'api/administration/externalCourses/GetList'
import {
  ExternalCourseParticipantsListParams,
  GetListResponse,
} from 'api/administration/externalCourseParticipants/GetList'

export const EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST =
  'EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST'
export const EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST_SUCCESS =
  'EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST_SUCCESS'
export const DESTROY_EXTERNAL_COURSE_PARTICIPANT =
  'DESTROY_EXTERNAL_COURSE_PARTICIPANT'
export const DESTROY_EXTERNAL_COURSE_PARTICIPANTS =
  'DESTROY_EXTERNAL_COURSE_PARTICIPANTS'
export const EXTERNAL_COURSE_PARTICIPANTS_LOADING =
  'EXTERNAL_COURSE_PARTICIPANTS_LOADING'
export const EXTERNAL_COURSE_UPLOAD_CERTIFICATE_SUCCESS =
  'EXTERNAL_COURSE_UPLOAD_CERTIFICATE_SUCCESS'

export interface ExternalCourseParticipantsListPayload {
  externalCourseId: number | string
  params: ExternalCourseParticipantsListParams
  callback?(resList: GetListResponse): void
}

export interface DestroyExternalCourseParticipantsPayload {
  ids: (number | string)[]
  externalCourseId?: number | string
  params?: ExternalCourseParticipantsListParams
  callback?(resList: GetListResponse): void
}

export interface DestroyExternalCourseCertificatesPayload {
  ids: (number | string)[]
  externalCourseId?: number | string
  params?: ExternalCourseParticipantsListParams
  callback?(resList: GetListResponse): void
}

export const Actions = {
  getList: (data: ExternalCourseParticipantsListPayload) =>
    createAction(EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST, data),
  setAdministrationListSuccess: (
    data: IExternalCourseParticipant[],
    total: number,
    perPage: number,
    sort?: ExternalCoursesListSort
  ) =>
    createAction(EXTERNAL_COURSE_PARTICIPANTS_ADMINISTRATION_GET_LIST_SUCCESS, {
      data,
      total,
      perPage,
      sort,
    }),
  destroyParticipant: (payload: DestroyExternalCourseParticipantPayload) =>
    createAction(DESTROY_EXTERNAL_COURSE_PARTICIPANT, payload),
  destroyParticipants: (payload: DestroyExternalCourseParticipantsPayload) =>
    createAction(DESTROY_EXTERNAL_COURSE_PARTICIPANTS, payload),
  setLoading: (loading: boolean) =>
    createAction(EXTERNAL_COURSE_PARTICIPANTS_LOADING, { loading }),
}

export type Actions = ActionsUnion<typeof Actions>
